var map = {
	"./apparel/apron/cover/cover.png": [
		11136,
		11136
	],
	"./apparel/pajama/cover/cover.png": [
		2962,
		2962
	],
	"./linen/fabric/cover/cover.png": [
		40940,
		18559
	],
	"./linen/hospital/cover/cover.png": [
		96749,
		96749
	],
	"./linen/hotel/cover/cover.png": [
		90273,
		90273
	],
	"./linen/restaurant/cover/cover.png": [
		81722,
		81722
	],
	"./linen/spa-and-resort/cover/cover.png": [
		3131,
		3131
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17015;
module.exports = webpackAsyncContext;